module.exports = __WEBPACK_EXTERNAL_MODULE_79__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Observable"
// module id = 79
// module chunks = 0